import React, { useRef, ReactNode } from "react";
import { Button } from "react-bootstrap";

export interface SntButtonProps {
  variant?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  icon?: ReactNode;
  text?: string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
  size?: "sm" | "lg";
  disabled?: boolean;
  setDisabled?: (disabled: boolean) => void;
  children?: ReactNode;
}

const SntButton: React.FC<SntButtonProps> = ({
  variant = "sensolus-greylight",
  onClick,
  icon,
  text = "",
  title = "",
  className = "",
  style = {},
  size,
  disabled = false,
  setDisabled,
  children,
}) => {
  const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!onClick) return;

    e.persist(); // Prevent event from being returned to the pool
    e.preventDefault();
    e.stopPropagation();

    if (disabled) return;
    if (setDisabled) {
      setDisabled(true);
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      onClick(e);
    });
  };

  return (
    <Button
      variant={variant}
      className={`${className}`}
      title={title || text}
      style={style}
      size={size}
      disabled={disabled}
      onClick={(e) => {
        handleClick(e);
      }}
    >
      <div className="d-flex align-items-center justify-content-center">
        <span style={{ lineHeight: "1.5" }}>{icon ? icon : ""}</span>
        {(text || children) && (
          <span className={`${icon ? "ms-1 d-none" : ""} d-lg-inline-block`}>
            {text || children}
          </span>
        )}
      </div>
    </Button>
  );
};

export default SntButton;
